import { Phone, Mail, ShoppingCart, User, Eye, Trash2, Edit, Link, Plus } from 'lucide-react'

export const MENU_ACTIONS = [
	{
		id: '1',
		icon: Phone,
		type: 'makeCall',
		label: 'Ligar',
	},
	{
		id: '2',
		icon: Mail,
		type: 'sendEmail',
		label: 'Enviar Email',
	},
	{
		id: '3',
		icon: ShoppingCart,
		type: 'startOrder',
		label: 'Iniciar Pedido',
	},
	{
		id: '4',
		icon: User,
		type: 'perfil',
		label: 'Visualizar Perfil',
	},
	{
		id: '5',
		icon: Eye,
		type: 'startView',
		label: 'Visualizar Cliente',
	},
	{
		id: '6',
		icon: Edit,
		type: 'startEdit',
		label: 'Editar',
	},
	{
		id: '7',
		icon: Trash2,
		type: 'delete',
		label: 'Excluir',
	},
	{
		id: '8',
		icon: Link,
		type: 'catalogoLink',
		label: 'Gerar Link Catálogo',
	},
	{
		id: '9',
		icon: Plus,
		type: 'add',
		disabled: false,
		label: 'Adicionar',
	},
]